<template>
    <div class="users-table-page weeduc-admin-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Usuários"
                    subtitle="Gerencie os usuários do sistema."
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    title="Criar novo usuário"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-courses-new-btn"
                    @click="$router.push('/dashboard/form-usuario')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        Novo usuário
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <div class="weeduc-admin-page__toolbar">
                    <v-row align="end" dense>
                        <v-col cols="12" md="5" lg="4">
                            <v-text-field
                                v-model="searchTerm"
                                label="Buscar"
                                placeholder="Nome, e-mail ou telefone..."
                                class="inputd weeduc-admin-v-field"
                                variant="outlined"
                                density="compact"
                                hide-details
                                clearable
                                append-inner-icon="mdi-magnify"
                                @update:model-value="onSearch"
                            />
                        </v-col>
                        <v-col cols="12" md="7" lg="8">
                            <div class="weeduc-admin-page__toolbar-field-row">
                                <v-select
                                    v-model="statusFilter"
                                    :items="statusFilterOptions"
                                    item-title="text"
                                    item-value="value"
                                    label="Status"
                                    variant="outlined"
                                    class="inputd weeduc-admin-v-field"
                                    :menu-props="adminSelectMenuProps"
                                    @update:modelValue="getUsersData()"
                                    density="compact"
                                    hide-details
                                />
                                <v-select
                                    v-model="typeFilter"
                                    :items="typeFilterOptions"
                                    item-title="text"
                                    item-value="value"
                                    label="Tipo"
                                    variant="outlined"
                                    class="inputd weeduc-admin-v-field"
                                    :menu-props="adminSelectMenuProps"
                                    @update:modelValue="getUsersData()"
                                    density="compact"
                                    hide-details
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <div class="weeduc-admin-page__table-section">
                    <v-table class="custom-table">
                        <thead>
                            <tr>
                                <th class="users-table__name-column">Nome</th>
                                <th class="text-center">Tipo</th>

                                <th class="text-center">Status</th>
                                <th>Telefone</th>
                                <th>Email</th>
                                <th class="text-center">Editar</th>
                                <th class="text-center">Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in filteredUsers" :key="user.id">
                                <td class="users-table__name-column">
                                    {{ user.name }}
                                </td>
                                <td class="text-center">
                                    {{ user.type == 3 ? 'Aluno' : 'Gestor' }}
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="
                                            user.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                    >
                                        {{
                                            user.status && user.status == 1
                                                ? 'Ativo'
                                                : 'Inativo'
                                        }}
                                    </v-chip>
                                </td>
                                <td>
                                    {{
                                        user.phone
                                            ? user.phone
                                            : 'Não informado'
                                    }}
                                </td>
                                <td>{{ user.email }}</td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="editUser(user.id)"
                                        icon
                                        variant="text"
                                        title="Editar usuário"
                                    >
                                        <Icon name="pencil" size="20" />
                                    </v-btn>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="danger"
                                        variant="text"
                                        @click="openDeleteModal(user.id)"
                                        icon
                                        title="Excluir usuário"
                                    >
                                        <Icon name="trash" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>
                <v-responsive class="weeduc-admin-page__pagination">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="isLoading"
                        @update:model-value="getUsersData"
                    ></v-pagination>
                </v-responsive>

                <Loader :isActive="!isLoading" />
            </div>
        </div>
        <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">
                        Você tem certeza que deseja excluir esse usuário?
                    </h3>
                </v-card-title>
                <v-card-subtitle>
                    Esta ação não poderá ser desfeita.
                </v-card-subtitle>
                <v-card-text>
                    <p class="mb-1">
                        Nome: <strong>{{ deletedUser.name }}</strong>
                    </p>
                    <p class="mb-1">
                        Email: <strong>{{ deletedUser.email }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="isDeleteDialogVisible = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="confirmDelete"
                        >Excluir</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { toast } from 'vue3-toastify';
    import { mapState } from 'vuex';
    import { debounce } from 'lodash';
    import ApiUser from '@/utils/user';
    import Loader from '@/components/Loader/loader.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        components: {
            Loader,
            TitlePage,
        },
        data() {
            return {
                usersData: [],
                usersFiltered: [],
                searchTerm: '',
                currentPage: 1,
                itemsPerPage: 10,
                totalPages: 0,
                isDeleteDialogVisible: false,
                deletedUser: null,
                isLoading: false,
                statusFilter: '',
                statusFilterOptions: [
                    { text: 'Todos', value: '' },
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 },
                ],
                typeFilter: '',
                typeFilterOptions: [
                    { text: 'Todos', value: '' },
                    { text: 'Aluno', value: 3 },
                    { text: 'Gestor', value: 2 },
                ],
            };
        },
        computed: {
            ...mapState(['token', 'numberIntensTable', 'websites', 'dark']),

            adminSelectMenuProps() {
                return this.dark
                    ? { contentClass: 'weeduc-admin-select-menu-dark' }
                    : {};
            },

            filteredUsers() {
                // Filtro de tipo implementado aqui
                let filtered = this.usersData;

                if (this.typeFilter !== '') {
                    filtered = filtered.filter(
                        (user) => user.type == this.typeFilter
                    );
                }

                return filtered;
            },
        },
        created() {
            this.getUsersData();
        },
        methods: {
            openDeleteModal(userId) {
                this.deletedUser = this.usersData.find(
                    (user) => user.id === userId
                );
                if (!this.deletedUser) {
                    toast.error('Usuário não encontrado');
                    return;
                }
                this.isDeleteDialogVisible = true;
            },
            editUser(id) {
                this.$router.push({ path: '/dashboard/form-usuario/' + id });
            },
            async getUsersData() {
                try {
                    this.isLoading = true;
                    const response = await ApiUser.getAllUser(
                        this.token,
                        this.currentPage - 1,
                        this.itemsPerPage,
                        this.searchTerm,
                        this.statusFilter,
                        this.typeFilter
                    );
                    this.usersData = response.content;
                    this.totalPages = response.totalPages;
                } catch (err) {
                    toast.error('Erro ao carregar listagem de usuários');
                } finally {
                    this.isLoading = false;
                }
            },
            async confirmDelete() {
                if (this.deletedUser) {
                    try {
                        this.isLoading = true;
                        await ApiUser.EditUser(
                            {
                                ...this.deletedUser,
                                status: 9,
                                id: undefined,
                                photoFinal: undefined,
                                dateInsert: undefined,
                                orderStatus: undefined,
                            },
                            this.token,
                            this.deletedUser.id
                        );
                        toast.success('Usuário excluído com sucesso');
                        this.getUsersData();
                    } catch (error) {
                        toast.error('Erro ao excluir usuário:', error);
                    } finally {
                        this.isDeleteDialogVisible = false;
                        this.isLoading = false;
                        this.deletedUser = { name: '', email: '' };
                    }
                }
            },
            onSearch: debounce(function () {
                this.getUsersData();
            }, 300),
        },
    };
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
</style>
